<script setup>
import { ref, computed } from 'vue';
// import dayjs from 'dayjs';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue';
// import { DatePickerRange, FormFieldDate } from '@/components';
import { LocationSearchInput } from '@/components/loads';
// import { defaultFilterValues } from '@/utils/myLoadsFiltersLookup.js';
import { useClickAway } from '@/utils/useClickAway';
import MyLoadsDesktopButtonComponent from '@/components/myLoads/MyLoadsDesktopButtonComponent.vue';
import { useScreenSize } from '@/composables/useScreenSize';
import DropdownComponent from '@/components/DropdownComponent.vue';

const { screenSize } = useScreenSize();

const isDesktop = computed(() => screenSize.value === 'desktop');

const emit = defineEmits(['closeModal']);
const modalRef = ref(null);
const brokerSearchFormRef = ref(null);
useClickAway(modalRef, () => emit('closeModal'));
useClickAway(brokerSearchFormRef, () => (showBrokerDropdown.value = false));

const router = useRouter();

const store = useStore();

const activePageTab = computed(
  () => router.currentRoute.value.query.tab || 'unassigned'
);

// const equipment_types = computed(() => store.state.loads.equipment_types);

const filters = computed(
  () => store.state.myLoadsStore[activePageTab.value].query
);

const handleResetFilters = () => {
  // store.dispatch('myLoads/setFilters', defaultFilterValues);
  // build query object from defaultFilterValues
  // entire form data is cleared and default values are pushed to the query
  // circle back if we don't want to push all default values
  const resetFilters = { ...filters.value };
  Object.keys(resetFilters).forEach((key) => {
    if (key !== 'tab' && key !== 'sort') {
      delete resetFilters[key];
    }
    resetFilters.page = 1;
  });
  router.push({
    query: resetFilters,
  });
};

const handleInputChange = (e, key) => {
  const value = e.target.value;
  store.commit('myLoadsStore/setQuery', {
    tab: activePageTab.value,
    query: {
      ...store.state.myLoadsStore[activePageTab.value].query,
      [key]: value,
    },
  });
};

const handleSearchInputClear = (key) => {
  store.commit('myLoadsStore/setQuery', {
    tab: activePageTab.value,
    query: {
      ...store.state.myLoadsStore[activePageTab.value].query,
      [key]: '',
    },
  });
  applyFilters();
};

// const handleEquipmentTypeChange = (value) => {
//   const equipment = filters.value.equipment || [];
//   if (equipment.includes(value)) {
//     store.commit('myLoadsStore/setFilter', {
//       filter: 'equipment',
//       value: equipment.filter((item) => item !== value),
//     });
//     return;
//   } else {
//     store.commit('myLoadsStore/setFilter', {
//       filter: 'equipment',
//       value: [...equipment, value],
//     });
//   }
// };

const applyFilters = () => {
  // handle validation if needed
  const activeFilters = { ...filters.value };
  Object.keys(activeFilters).forEach((key) => {
    if (activeFilters[key] === '' || activeFilters[key] === undefined) {
      delete activeFilters[key];
    }
    if (key === 'equipment') {
      if (
        Array.isArray(activeFilters[key]) &&
        activeFilters[key].length === 0
      ) {
        delete activeFilters[key];
      } else {
        activeFilters[key] = activeFilters[key].join(',');
      }
    }
  });
  // console.log('Applying filters:', activeFilters, activePageTab.value);
  router.push({
    query: {
      tab: activePageTab.value,
      ...activeFilters,
      page: 1,
    },
  });
  emit('closeModal');
};

const canSearchBrokers = computed(
  () => store.state.users.featureFlags?.carrier_can_search_brokers?.enabled
);

// const pickupPlaceholder = computed(() => {
//   if (filters.value.pickupStart && filters.value.pickupEnd) {
//     return `${dayjs(filters.value.pickupStart).format('MMM DD, YYYY')} - ${dayjs(filters.value.pickupEnd).format('MMM DD, YYYY')}`;
//   } else {
//     return '';
//   }
// });
// const deliveryPlaceholder = computed(() => {
//   if (filters.value.deilveryStart && filters.value.deliveryEnd) {
//     return `${dayjs(filters.value.deliveryStart).format('MMM DD, YYYY')} - ${dayjs(filters.value.deliveryEnd).format('MMM DD, YYYY')}`;
//   } else {
//     return '';
//   }
// });

// const showPickupDatePicker = ref(false);
// const showDeliveryDatePicker = ref(false);

// const initialDate = computed(() => {
//   return dayjs().format('MM/DD/YYYY');
// });

// const selectedPickupDate = ref(filters.value.pickupStart || initialDate.value);
// const selectedPickupEndDate = ref(filters.value.pickupEnd || '');
// const selectedDeliveryDate = ref(
//   filters.value.deliveryStart || initialDate.value
// );
// const selectedDeliveryEndDate = ref(filters.value.deliveryEnd || '');

// const startPickupDate = computed(() => {
//   return selectedPickupDate.value
//     ? dayjs(selectedPickupDate.value).format('YYYY-MM-DD')
//     : undefined;
// });
// const endPickupDate = computed(() => {
//   return selectedPickupEndDate.value
//     ? dayjs(selectedPickupEndDate.value).format('YYYY-MM-DD')
//     : undefined;
// });

// const startDeliveryDate = computed(() => {
//   return selectedDeliveryDate.value
//     ? dayjs(selectedDeliveryDate.value).format('YYYY-MM-DD')
//     : undefined;
// });
// const endDeliveryDate = computed(() => {
//   return selectedDeliveryEndDate.value
//     ? dayjs(selectedDeliveryEndDate.value).format('YYYY-MM-DD')
//     : undefined;
// });

// function dynamicUpdatePickupDate({ value }) {
//   if (value) {
//     store.commit('myLoadsStore/setFilter', {
//       filter: 'pickupStart',
//       value: selectedPickupDate.value,
//     });
//     store.commit('myLoadsStore/setFilter', {
//       filter: 'pickupEnd',
//       value: selectedPickupEndDate.value,
//     });
//   }
//   applyFilters();
// }

// const setSelectedPickupDay = (fieldValue, dateSelected) => {
//   if (
//     !selectedPickupDate.value ||
//     (selectedPickupDate.value && selectedPickupEndDate.value)
//   ) {
//     // set pickup start range
//     selectedPickupDate.value = dayjs(dateSelected).format('YYYY-MM-DD');
//     selectedPickupEndDate.value = undefined;
//   } else {
//     // set pickup end range
//     selectedPickupEndDate.value = dayjs(dateSelected).format('YYYY-MM-DD');
//     dynamicUpdatePickupDate({ name: fieldValue, value: dateSelected });
//     showPickupDatePicker.value = false;
//   }
// };

// const toggleShowPickupDatePicker = () => {
//   showPickupDatePicker.value = !showPickupDatePicker.value;
// };

// function dynamicUpdateDeliveryDate({ value }) {
//   if (value) {
//     store.commit('myLoadsStore/setFilter', {
//       filter: 'deliveryStart',
//       value: selectedDeliveryDate.value,
//     });
//     store.commit('myLoadsStore/setFilter', {
//       filter: 'deliveryEnd',
//       value: selectedDeliveryEndDate.value,
//     });
//   }
//   applyFilters();
// }

// const setSelectedDeliveryDay = (fieldValue, dateSelected) => {
//   if (
//     !selectedDeliveryDate.value ||
//     (selectedDeliveryDate.value && selectedDeliveryEndDate.value)
//   ) {
//     // set delivery start range
//     selectedDeliveryDate.value = dayjs(dateSelected).format('YYYY-MM-DD');
//     selectedDeliveryEndDate.value = undefined;
//   } else {
//     // set delivery end range
//     selectedDeliveryEndDate.value = dayjs(dateSelected).format('YYYY-MM-DD');
//     dynamicUpdateDeliveryDate({ name: fieldValue, value: dateSelected });
//     showDeliveryDatePicker.value = false;
//   }
// };

// const toggleShowDeliveryDatePicker = () => {
//   showDeliveryDatePicker.value = !showDeliveryDatePicker.value;
// };

const setOriginFilters = (origin) => {
  if (!origin) {
    store.commit('myLoadsStore/setQuery', {
      tab: activePageTab.value,
      query: {
        ...store.state.myLoadsStore[activePageTab.value].query,
        origin: origin,
        originAreaId: '',
        originState: '',
      },
    });
    return;
  }
  store.commit('myLoadsStore/setQuery', {
    tab: activePageTab.value,
    query: {
      ...store.state.myLoadsStore[activePageTab.value].query,
      origin: origin,
    },
  });
};

const setSelectedOrigin = (areaInformation) => {
  store.commit('myLoadsStore/setQuery', {
    tab: activePageTab.value,
    query: {
      ...store.state.myLoadsStore[activePageTab.value].query,
      originAreaId: areaInformation?.id,
    },
  });
  if (areaInformation.is_type === 'state') {
    store.commit('myLoadsStore/setQuery', {
      tab: activePageTab.value,
      query: {
        ...store.state.myLoadsStore[activePageTab.value].query,
        originState: areaInformation?.code,
      },
    });
  } else {
    store.commit('myLoadsStore/setQuery', {
      tab: activePageTab.value,
      query: {
        ...store.state.myLoadsStore[activePageTab.value].query,
        originZip: areaInformation?.code,
      },
    });
  }

  applyFilters();
};

const setDestinationFilters = (destination) => {
  if (!destination) {
    store.commit('myLoadsStore/setQuery', {
      tab: activePageTab.value,
      query: {
        ...store.state.myLoadsStore[activePageTab.value].query,
        destination: destination,
        destinationAreaId: '',
        destinationState: '',
      },
    });
    return;
  }
  store.commit('myLoadsStore/setQuery', {
    tab: activePageTab.value,
    query: {
      ...store.state.myLoadsStore[activePageTab.value].query,
      destination: destination,
    },
  });
};

const setSelectedDestination = (areaInformation) => {
  store.commit('myLoadsStore/setQuery', {
    tab: activePageTab.value,
    query: {
      ...store.state.myLoadsStore[activePageTab.value].query,
      destinationAreaId: areaInformation?.id,
    },
  });
  if (areaInformation.is_type === 'state') {
    store.commit('myLoadsStore/setQuery', {
      tab: activePageTab.value,
      query: {
        ...store.state.myLoadsStore[activePageTab.value].query,
        destinationState: areaInformation?.code,
      },
    });
  } else {
    store.commit('myLoadsStore/setQuery', {
      tab: activePageTab.value,
      query: {
        ...store.state.myLoadsStore[activePageTab.value].query,
        destinationZip: areaInformation?.code,
      },
    });
  }
  applyFilters();
};

// const clearPickup = () => {
//   store.commit('myLoadsStore/setFilter', { filter: 'pickupStart', value: '' });
//   store.commit('myLoadsStore/setFilter', { filter: 'pickupEnd', value: '' });
//   applyFilters();
// };

// const clearDelivery = () => {
//   store.commit('myLoadsStore/setFilter', {
//     filter: 'deliveryStart',
//     value: '',
//   });
//   store.commit('myLoadsStore/setFilter', { filter: 'deliveryEnd', value: '' });
//   applyFilters();
// };

const filtersCount = computed(
  () => store.state.myLoadsStore[activePageTab.value].activeFiltersCount
);

const isBrokersLoading = computed(() => {
  return store.state.myLoadsStore.brokers.isLoading;
});

const brokersDropdownList = computed(() => {
  return store.state.myLoadsStore.brokers.allBrokers.map((broker) => ({
    id: broker.id,
    label: broker.legal_name,
  }));
});

const brokersDropdownListFiltered = computed(() => {
  const filtered = brokersDropdownList.value.filter((broker) =>
    broker.label
      .toLowerCase()
      .includes(
        filters.value.brokerName ? filters.value.brokerName.toLowerCase() : ''
      )
  );
  if (filters.value.brokerId) {
    return [...filtered, { id: 'clear', label: 'Clear Selection' }];
  }
  return filtered;
});

const clearBrokerSearch = () => {
  store.commit('myLoadsStore/setQuery', {
    tab: activePageTab.value,
    query: {
      ...store.state.myLoadsStore[activePageTab.value].query,
      brokerId: '',
      brokerName: '',
    },
  });
  applyFilters();
};

const handleDropdownClick = (item, source) => {
  console.log('Selected dropdown item:', item);
  if (source !== 'broker') return;
  if (item.id === 'clear') {
    clearBrokerSearch();
    showBrokerDropdown.value = false;
    return;
  }
  store.commit('myLoadsStore/setQuery', {
    tab: activePageTab.value,
    query: {
      ...store.state.myLoadsStore[activePageTab.value].query,
      brokerId: item.id,
      brokerName: item.label,
    },
  });
  showBrokerDropdown.value = false;
  applyFilters();
};

const showBrokerDropdown = ref(false);
</script>
<!-- w-[350px] -->
<template>
  <div
    ref="modalRef"
    class="flex max-w-[300px] flex-col items-start"
  >
    <div
      class="border-1 relative flex w-full flex-col overflow-y-scroll rounded-t-[5px] border border-b-0 border-neutral-300-a bg-white pb-4 pt-6 shadow-[0px_1px_6px_0px_rgba(160,160,160,0.22)]"
      :class="isDesktop ? 'h-[calc(100vh-320px)]' : 'max-h-[calc(100vh-120px)]'"
    >
      <div
        v-if="!isDesktop"
        class="flex w-full items-center justify-start px-3"
      >
        <MyLoadsDesktopButtonComponent
          button-class="subtle-button rounded-[5px] p-0.5"
          @button-click="emit('closeModal')"
        >
          <template #leftIcon>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
            >
              <path
                d="M24.4852 9.40039L22.5996 7.51477L15.9999 14.1144L9.40027 7.51477L7.51465 9.40039L14.1143 16.0001L7.51465 22.5997L9.40027 24.4853L15.9999 17.8857L22.5996 24.4853L24.4852 22.5997L17.8855 16.0001L24.4852 9.40039Z"
                fill="#6C7C9D"
              />
            </svg>
          </template>
        </MyLoadsDesktopButtonComponent>
      </div>
      <!-- <span
        class="flex w-full cursor-pointer items-center justify-center rounded-t-md bg-sun-400 px-2 text-sm"
        :class="{
          'text-info-bold-text bg-sun-400 hover:bg-yellow-200 hover:text-yellow-700':
            !isLoading,
          'bg-yellow-300 text-yellow-800': isLoading,
        }"
        @click="handleResetFilters"
        >Reset
        <svg
          class="ml-1 h-4 w-4"
          :class="{ 'spin-quick': isLoading }"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z"
            clip-rule="evenodd"
          ></path>
        </svg>
      </span> -->
      <!-- Load ID Search -->
      <Disclosure
        v-slot="{ open }"
        :default-open="true"
      >
        <DisclosureButton
          class="flex w-full items-center justify-between px-4 py-3"
          @click.stop
        >
          <div class="text-sm font-semibold text-steel-1100">Load ID</div>
          <div class="flex gap-2">
            <svg
              :class="open ? '-rotate-90 transform' : ''"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 18L15 12L9 6"
                stroke="#47536B"
                stroke-width="2"
              />
            </svg>
          </div>
        </DisclosureButton>
        <transition
          enter-active-class="transition duration-25 ease-out"
          enter-from-class="transform scale-95 opacity-0"
          enter-to-class="transform scale-100 opacity-100"
          leave-active-class="transition duration-75 ease-out"
          leave-from-class="transform scale-100 opacity-100"
          leave-to-class="transform scale-95 opacity-0"
        >
          <DisclosurePanel>
            <div class="relative p-3">
              <form class="relative mb-2 flex items-center gap-2">
                <input
                  :value="filters.loadId"
                  type="text"
                  class="h-12 w-full rounded-md border-light-gray bg-lighter-gray bg-opacity-30 pr-16 text-sm text-gray-500 shadow-sm outline-none"
                  placeholder="Search Load ID"
                  maxLength="100"
                  @input="(event) => handleInputChange(event, 'loadId')"
                />
                <button
                  type="button"
                  class="absolute bottom-0 right-0 top-0 flex w-8 flex-col justify-center bg-transparent text-placeholder-gray hover:text-yellow-500"
                  @click="applyFilters"
                >
                  <img
                    class="h-4 w-4 cursor-pointer"
                    src="@/assets/search-light-gray.svg"
                    alt="search icon"
                  />
                </button>
                <img
                  v-if="filters.loadId"
                  class="absolute right-12 top-[18px] h-3 w-3 cursor-pointer opacity-30"
                  src="@/assets/close-icon.svg"
                  alt="close icon"
                  @click="handleSearchInputClear('loadId')"
                />
              </form>
            </div>
          </DisclosurePanel>
        </transition>
      </Disclosure>
      <!-- Broker Search -->
      <Disclosure
        v-if="canSearchBrokers"
        v-slot="{ open }"
        :default-open="true"
      >
        <DisclosureButton
          class="flex w-full items-center justify-between px-4 py-3"
          @click.stop
        >
          <div class="text-sm font-semibold text-steel-1100">Broker</div>
          <div class="flex gap-2">
            <svg
              :class="open ? '-rotate-90 transform' : ''"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 18L15 12L9 6"
                stroke="#47536B"
                stroke-width="2"
              />
            </svg>
          </div>
        </DisclosureButton>
        <transition
          enter-active-class="transition duration-25 ease-out"
          enter-from-class="transform scale-95 opacity-0"
          enter-to-class="transform scale-100 opacity-100"
          leave-active-class="transition duration-75 ease-out"
          leave-from-class="transform scale-100 opacity-100"
          leave-to-class="transform scale-95 opacity-0"
        >
          <DisclosurePanel>
            <div class="relative p-3">
              <form
                ref="brokerSearchFormRef"
                class="relative mb-2 flex items-center gap-2"
              >
                <input
                  v-model="filters.brokerName"
                  type="text"
                  class="h-12 w-full rounded-md border-light-gray bg-lighter-gray bg-opacity-30 pr-16 text-sm text-gray-500 shadow-sm outline-none"
                  placeholder="Search Broker"
                  maxLength="100"
                  @click.stop="showBrokerDropdown = true"
                  @focus="showBrokerDropdown = true"
                  @input="(event) => handleInputChange(event, 'brokerName')"
                />
                <!-- @blur="showBrokerDropdown = false" -->

                <button
                  :disabled="true"
                  type="button"
                  class="absolute bottom-0 right-0 top-0 flex w-8 flex-col justify-center bg-transparent text-placeholder-gray hover:text-yellow-500"
                >
                  <img
                    class="h-4 w-4 cursor-pointer"
                    src="@/assets/search-light-gray.svg"
                    alt="search icon"
                  />
                </button>

                <img
                  v-if="filters.brokerName"
                  class="absolute right-12 top-[18px] h-3 w-3 cursor-pointer opacity-30"
                  src="@/assets/close-icon.svg"
                  alt="close icon"
                  @click="clearBrokerSearch"
                />
                <DropdownComponent
                  :is-dropdown-visible="
                    (isBrokersLoading ||
                      brokersDropdownListFiltered?.length > 0) &&
                    showBrokerDropdown
                  "
                  :selected-item-id="filters.brokerId"
                  :selected-class="'border-sun-400 text-sun-400'"
                  text-size="text-sm"
                  :source="'broker'"
                  :dropdown-list="brokersDropdownListFiltered"
                  @dropdown-click="handleDropdownClick"
                />
              </form>
            </div>
          </DisclosurePanel>
        </transition>
      </Disclosure>
      <!-- Location Search -->
      <Disclosure
        v-slot="{ open }"
        :default-open="true"
      >
        <DisclosureButton
          class="flex w-full items-center justify-between px-4 py-3"
          @click.stop
        >
          <div class="text-sm font-semibold text-steel-1100">Location</div>
          <div class="flex gap-2">
            <svg
              :class="open ? '-rotate-90 transform' : ''"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 18L15 12L9 6"
                stroke="#47536B"
                stroke-width="2"
              />
            </svg>
          </div>
        </DisclosureButton>
        <transition
          enter-active-class="transition duration-25 ease-out"
          enter-from-class="transform scale-95 opacity-0"
          enter-to-class="transform scale-100 opacity-100"
          leave-active-class="transition duration-75 ease-out"
          leave-from-class="transform scale-100 opacity-100"
          leave-to-class="transform scale-95 opacity-0"
        >
          <DisclosurePanel>
            <div class="px-3 pt-2">
              <div class="relative flex flex-col gap-2 pb-2">
                <div class="flex items-center">
                  <p
                    class="w-full text-left text-xs font-semibold uppercase text-neutral-boldest"
                  >
                    Origin
                  </p>
                </div>
                <div class="flex gap-3">
                  <LocationSearchInput
                    type="origin"
                    placeholder="Select an Origin"
                    :is-slim="false"
                    :input-value="filters.origin"
                    :show-clear-icon="true"
                    @set-location="setOriginFilters"
                    @set-selected-location="setSelectedOrigin"
                  ></LocationSearchInput>
                </div>
              </div>

              <div class="relative flex flex-col gap-2 pb-2">
                <div class="flex items-center">
                  <p
                    class="w-full text-left text-xs font-semibold uppercase text-neutral-boldest"
                  >
                    Destination
                  </p>
                </div>
                <div class="flex gap-3">
                  <LocationSearchInput
                    type="destination"
                    placeholder="Select a Destination"
                    :is-slim="false"
                    :show-clear-icon="true"
                    :input-value="filters.destination"
                    @set-location="setDestinationFilters"
                    @set-selected-location="setSelectedDestination"
                  ></LocationSearchInput>
                </div>
              </div>
            </div>
          </DisclosurePanel>
        </transition>
      </Disclosure>
      <!-- Date Search -->
      <!-- <Disclosure
        v-slot="{ open }"
        :default-open="true"
      >
        <DisclosureButton
          class="flex w-full items-center justify-between px-4 py-3"
          @click.stop
        >
          <div class="text-sm font-semibold text-steel-1100">Dates</div>
          <div class="flex gap-2">
            <svg
              :class="open ? '-rotate-90 transform' : ''"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 18L15 12L9 6"
                stroke="#47536B"
                stroke-width="2"
              />
            </svg>
          </div>
        </DisclosureButton>
        <transition
          enter-active-class="transition duration-25 ease-out"
          enter-from-class="transform scale-95 opacity-0"
          enter-to-class="transform scale-100 opacity-100"
          leave-active-class="transition duration-75 ease-out"
          leave-from-class="transform scale-100 opacity-100"
          leave-to-class="transform scale-95 opacity-0"
        >
          <DisclosurePanel>
            <div class="px-3 pb-3">
              <div class="relative mt-2 w-full">
                <p
                  class="text-left text-xs font-semibold uppercase text-neutral-boldest"
                >
                  Pickup Date Range
                </p>
                <form-field-date
                  label=" "
                  placeholder=""
                  :model-value="pickupPlaceholder"
                  name="pickup_date"
                  input-type="date"
                  :is-slim="true"
                  :hidden="false"
                  :monospace="false"
                  :show-confirm-button="false"
                  @update:model-value="dynamicUpdatePickupDate"
                  @toggle-date-picker="toggleShowPickupDatePicker"
                />

                <img
                  v-if="pickupPlaceholder"
                  class="absolute right-14 top-10 z-30 h-3 w-3 cursor-pointer opacity-30"
                  src="@/assets/close-icon.svg"
                  alt="close icon"
                  @click="clearPickup"
                />

                <div
                  v-show="showPickupDatePicker"
                  class="absolute right-0 top-full z-50 rounded-lg bg-white p-4 shadow-md"
                >
                  <date-picker-range
                    :start-date="startPickupDate"
                    :end-date="endPickupDate"
                    :field="'pickup_datepicker'"
                    date-format="MM/DD/YYYY"
                    @day-selected="setSelectedPickupDay"
                  />
                </div>
              </div>

              <div class="relative mt-2 w-full">
                <p
                  class="text-left text-xs font-semibold uppercase text-neutral-boldest"
                >
                  Delivery Date Range
                </p>
                <form-field-date
                  label=" "
                  placeholder=""
                  :model-value="deliveryPlaceholder"
                  name="pickup_date"
                  input-type="date"
                  :is-slim="true"
                  :hidden="false"
                  :monospace="false"
                  :show-confirm-button="false"
                  @update:model-value="dynamicUpdateDeliveryDate"
                  @toggle-date-picker="toggleShowDeliveryDatePicker"
                />

                <img
                  v-if="deliveryPlaceholder"
                  class="absolute right-14 top-10 z-30 h-3 w-3 cursor-pointer opacity-30"
                  src="@/assets/close-icon.svg"
                  alt="close icon"
                  @click="clearDelivery"
                />

                <div
                  v-show="showDeliveryDatePicker"
                  class="absolute right-0 top-full z-50 rounded-lg bg-white p-4 shadow-md"
                >
                  <date-picker-range
                    :start-date="startDeliveryDate"
                    :end-date="endDeliveryDate"
                    :field="'pickup_datepicker'"
                    date-format="MM/DD/YYYY"
                    @day-selected="setSelectedDeliveryDay"
                  />
                </div>
              </div>
            </div>
          </DisclosurePanel>
        </transition>
      </Disclosure> -->
      <!-- Equipment Types -->
      <!-- <Disclosure
        v-slot="{ open }"
        :default-open="true"
      >
        <DisclosureButton
          class="flex w-full items-center justify-between px-3 py-3"
          @click.stop
        >
          <div class="text-sm font-medium leading-none text-steel-1100">
            Equipment Types
          </div>
          <div class="flex gap-2">
            <svg
              :class="open ? '-rotate-90 transform' : ''"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 18L15 12L9 6"
                stroke="#47536B"
                stroke-width="2"
              />
            </svg>
          </div>
        </DisclosureButton>
        <transition
          enter-active-class="transition duration-25 ease-out"
          enter-from-class="transform scale-95 opacity-0"
          enter-to-class="transform scale-100 opacity-100"
          leave-active-class="transition duration-75 ease-out"
          leave-from-class="transform scale-100 opacity-100"
          leave-to-class="transform scale-95 opacity-0"
        >
          <DisclosurePanel>
            <div class="flex flex-wrap gap-2 p-3">
              <span
                v-for="[key, value] in Object.entries(equipment_types)"
                :key="key"
                class="w-max cursor-pointer rounded-full bg-lighter-gray px-2 text-sm capitalize"
                :class="{
                  'bg-yellow-500': filters.equipment?.includes(key),
                }"
                @click="handleEquipmentTypeChange(key)"
              >
                {{ value }}
              </span>
            </div>
          </DisclosurePanel>
        </transition>
      </Disclosure> -->
    </div>
    <div
      class="border-1 flex h-14 w-full items-center justify-between gap-5 rounded-b-[5px] border border-t-0 border-neutral-300-a bg-white px-3"
    >
      <div
        class="text-xs font-medium leading-none tracking-tight text-steel-700"
      >
        {{ `${filtersCount} Filter${filtersCount === 1 ? '' : 's'} Selected` }}
      </div>
      <MyLoadsDesktopButtonComponent
        button-class="flex items-center default-button rounded-[5px]"
        text-class="text-sm font-medium leadin-loose tracking-tight"
        button-text="Reset Filters"
        @button-click="handleResetFilters"
      >
        <template #leftIcon>
          <svg
            height="16"
            width="16"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z"
              clip-rule="evenodd"
            ></path>
          </svg>
        </template>
      </MyLoadsDesktopButtonComponent>
    </div>
  </div>
</template>

<style>
.vcp.vcp--expandable {
  cursor: pointer;
}

.vcp.vcp--expandable > .vcp__header:hover {
  background: #f7f7fa;
}

.vcp.vcp--expandable > .vcp__header {
  /* margin-left: -0.75rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  width: calc(100% + 1.5rem); */
}

.vcp.vcp--expandable:not(.vcp--expanded) > .vcp__header > .vcp__header-icon {
  /* transform: rotate(-90deg) !important; */
}

.vcp.vcp--expandable.vcp--expanded > .vcp__header > .vcp__header-icon {
  /* transform: rotate(0deg) !important; */
}

.vcp__body {
  margin-bottom: 1rem;
}

.field-date > div > label {
  @apply text-gray-over-dark;
}

.field-date input {
  padding-top: 14px;
  padding-bottom: 14px;

  @apply text-xs;
}

.team-dropdown-filter {
  @apply text-sm;
}

.team-dropdown-filter > div:first-child {
  @apply px-3;
}

.team-dropdown-filter svg {
  @apply h-6 w-6 text-gray-400;
}
</style>
